const CAMPAIGN_DISCOUNT = 'campaign-discount';

const getTransactionType = (type) => {
  switch (type) {
  case 'card':
    return 'Card';
  case 'bank_account':
    return 'ACH';
  case 'invoice':
    return 'Invoice';
  case 'debit':
    return 'Debit';
  default:
    return ' - ';
  }
};

const hasCampaignDiscount = (transactionList) =>
  (transactionList ?? []).some((transaction) =>
    transaction.entries?.some((entry) => entry.label === CAMPAIGN_DISCOUNT));

// A shift is discounted by at most one campaign: campaign-service keeps one
// live redemption per job family (the claim key comes from the shared
// transaction id), recorded against whichever shift claimed it, so a repost
// is named through its family's live redemption. A family whose claim was
// freed (an office cancellation refunded in full) holds none live, yet payment
// copied the discount line onto the repost, so the freed one names it then.
const campaignNameForJob = (history, jobId, familyJobIds = []) => {
  const inFamily = (id) => familyJobIds.includes(id);
  return (history.find((row) => row.jobIds.includes(jobId))
    ?? history.find((row) => row.liveJobIds.some(inFamily))
    ?? history.find((row) => row.jobIds.some(inFamily)))?.campaignName;
};

export { CAMPAIGN_DISCOUNT, campaignNameForJob, getTransactionType, hasCampaignDiscount };
